var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "login" } }, [
    _c("h2", [_vm._v("ログイン")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.result,
            expression: "result"
          }
        ]
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.success,
                expression: "!success"
              }
            ]
          },
          [
            _c("p", { staticClass: "has-text-danger" }, [
              _vm._v(_vm._s(_vm.errMsg))
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "lds-roller"
      },
      [
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loading && _vm.main,
            expression: "!loading && main"
          }
        ]
      },
      [
        _c(
          "section",
          [
            _c(
              "b-field",
              { attrs: { horizontal: "", label: "メールアドレス" } },
              [
                _c("b-input", {
                  attrs: { type: "email", maxlength: "50" },
                  model: {
                    value: _vm.email,
                    callback: function($$v) {
                      _vm.email = typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "email"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-field",
              { attrs: { horizontal: "", label: "パスワード" } },
              [
                _c("b-input", {
                  attrs: { type: "password", "password-reveal": "" },
                  model: {
                    value: _vm.password,
                    callback: function($$v) {
                      _vm.password = typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "password"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: {
                  click: function($event) {
                    _vm.exec()
                  }
                }
              },
              [_vm._v("ログイン")]
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("router-link", { attrs: { to: "/reset" } }, [
              _vm._v("パスワードを忘れた方")
            ]),
            _vm._v(" |\n      "),
            _c("router-link", { attrs: { to: "/signup" } }, [
              _vm._v("ユーザー作成はこちら")
            ])
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 